/* Common Imports */

import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */

import { Typography } from "@material-ui/core";

/* Image Imports */

import sixThirtyAM from "../../../public/images/icons/heavie/singleproperty/totd-0630-am.webp";
import fourThirtyPM from "/public/images/icons/heavie/singleproperty/totd-0430-pm.webp";
import sixThirtyPM from "/public/images/icons/heavie/singleproperty/totd-0630-pm.webp";
import eightPM from "/public/images/icons/heavie/singleproperty/totd-0800-pm.webp";
import tenPM from "/public/images/icons/heavie/singleproperty/totd-1000-pm.webp";
import elevenAM from "/public/images/icons/heavie/singleproperty/totd-1100-am.webp";

/* Icon Imports */

/* Data Imports */

import AppConfig from "../../../AppConfig";

/* Styles */
const useStyles = makeStyles((theme) => ({
  megaContainer: {
    width: "100%",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 5rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 5rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 5rem 72rem",
    },
    margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      // margin: "0rem 0rem 2rem 0rem",
      display: "none",
    },
  },
  mainContainer: {
    padding: "2.5rem 8rem 2.5rem 8rem",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "1rem",
    margin: "0rem 0rem 1rem 0rem",
    [theme.breakpoints.down("md")]: {
      width: " 100%",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "0rem",
    },
  },
  heading: {
    width: "40%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",

    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  illustrationSizer: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    marginBottom: "1.5rem",
  },
  stepper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "1.5rem 0rem 1.5rem 0rem",
    "& .MuiStepConnector-root": {
      display: "none",
    },
    "& .MuiStep-alternativeLabel": {
      padding: "0rem 0rem 0rem 0rem",
      flex: "none",
    },
  },
  step: {
    transition: "all .25s ease-in-out",
    "&:hover": {
      transform: "scale(1.2)",
      "-webkit-transform": "scale(1.2)",
      "-moz-transform": "scale(1.2)",
    },
  },
  stepBtn: {
    cursor: "pointer",
  },
  divider: {
    color: "#666666",
    height: "2.5px",
    flex: "auto",
  },
  timeButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "1rem",
    // margin: "2rem 0rem 1rem 0rem",
    margin: "0rem 0rem 0rem 0rem",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      width: " 100%",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "1rem",
      margin: "0rem 0rem 0rem 0rem",
    },
  },
  timeButton: {
    padding: "0.5rem 1rem",
    fontSize: "0.813rem",
    fontWeight: "500",
    color: "#693471",
    background: "#FFFFFF",
    border: "1px solid #693471",
    borderRadius: "0.5rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "#693471",
      color: "#FFFFFF",
    },
  },
  activeTimeButton: {
    background: "#693471",
    color: "#FFFFFF",
  },
}));

const TimeofTheDaySection = () => {
  const classes = useStyles();
  const [imgSrc, setImgSrc] = React.useState(sixThirtyAM.src);
  const [activeStep, setActiveStep] = React.useState(1);

  React.useEffect(() => {
    if (activeStep === 1) {
      setImgSrc(sixThirtyAM.src);
    } else if (activeStep === 2) {
      setImgSrc(elevenAM.src);
    } else if (activeStep === 3) {
      setImgSrc(fourThirtyPM.src);
    } else if (activeStep === 4) {
      setImgSrc(sixThirtyPM.src);
    } else if (activeStep === 5) {
      setImgSrc(eightPM.src);
    } else if (activeStep === 6) {
      setImgSrc(tenPM.src);
    }
  }, [activeStep]);

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <Typography
            variant="h1"
            component="h1"
            className={classes.heading}
          >
            Time of the day
          </Typography>
          <div className={classes.timeButtons}>
            <button
              className={`${classes.timeButton} ${activeStep === 1 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(1)}
            >
              8:00 AM
            </button>
            <button
              className={`${classes.timeButton} ${activeStep === 2 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(2)}
            >
              10.00 AM
            </button>
            <button
              className={`${classes.timeButton} ${activeStep === 3 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(3)}
            >
              4:30 PM
            </button>
            <button
              className={`${classes.timeButton} ${activeStep === 4 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(4)}
            >
              6:00 PM
            </button>
            <button
              className={`${classes.timeButton} ${activeStep === 5 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(5)}
            >
              8:00 PM
            </button>
            <button
              className={`${classes.timeButton} ${activeStep === 6 ? classes.activeTimeButton : ""}`}
              onClick={() => setActiveStep(6)}
            >
              10:00 PM
            </button>
          </div>
        </div>

        <img
          src={imgSrc}
          alt={AppConfig.imageAltText}
          width={512}
          height={512}
          loading="eager"
          referrerPolicy="no-referrer"
          className={classes.illustrationSizer}
        />
      </div>
    </React.Fragment>
  );
};

export default TimeofTheDaySection;
